import { put, select } from 'redux-saga/effects';
import { get } from 'lodash';
import apolloClient from './apolloClient';
import {
  verifyAuth,
  RECEIVE_REGISTRATION_ID,
  RECEIVE_REGISTRATION_ID_FAIL,
  RECEIVE_REGISTRATION_ID_IN_PROGRESS,
} from '../auth/auth';
import LOOKUP_REGISTRATION_BY_USER_QUERY from './lookupRegistrationByUser.query';

export const APP_INITIALIZE = 'APP_INITIALIZE';

export function* appInitialize() {
  console.log('App Initializing..');
  try {
    yield verifyAuth();
    yield getAssociatedRegistrationId();
  } catch (e) {
    console.log(e);
  }
}

export function* getAssociatedRegistrationId() {
  console.log('getAssociatedRegistrationId');
  yield put({
    type: 'auth/RECEIVE_REGISTRATION_ID_IN_PROGRESS',
  });
  const userId = yield select(state => state.user.id);
  const response = userId
    ? yield apolloClient.query({
        query: LOOKUP_REGISTRATION_BY_USER_QUERY,
        variables: { userId: userId.toString() },
      })
    : null;
  const registrationId = get(response, 'data.lookupRegistrationByUser[0].id');
  if (!registrationId) {
    yield put({
      type: 'auth/RECEIVE_REGISTRATION_ID_FAIL',
    });
    return;
  }
  yield put({
    type: RECEIVE_REGISTRATION_ID,
    data: { registrationId },
  });
}



// WEBPACK FOOTER //
// ./src/_app/middleware/initialize.js